var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiceSolid = function SvgDiceSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1 0 13l12 12 12-12zm0 2.8 9.2 9.2-9.2 9.2L2.8 13zM12 8a1 1 0 0 0 0 2 1 1 0 0 0 0-2m-4 4a1 1 0 0 0 0 2 1 1 0 0 0 0-2m4 0a1 1 0 0 0 0 2 1 1 0 0 0 0-2m4 0a1 1 0 0 0 0 2 1 1 0 0 0 0-2m10.8 1-2 2H30v12H18v-5.2l-2 2V29h16V13zM12 16a1 1 0 0 0 0 2 1 1 0 0 0 0-2m12 4a1 1 0 0 0 0 2 1 1 0 0 0 0-2"
  })));
};
export default SvgDiceSolid;